import React from "react";
import Skeleton from "../../skeleton";

const Mobile = () => (

	<>
		<div className="card-skeleton-tab-product">
			<div className="card-skeleton-tab-product__section-product">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-product__product">
					{Array.from({ length: 4 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-product__product-data">
							<Skeleton
								width="80px"
								height="80px"
							/>
							<div className="card-skeleton-tab-product__product-description">
								<Skeleton
									width="100px"
									height="16px"
								/>
								<Skeleton
									width="160px"
									height="16px"
								/>
							</div>
						</div>
					))}
				</div>
				<div className="card-skeleton-tab-product__product-button">
					<Skeleton
						width="240px"
						height="40px"
						margin="auto"
					/>
				</div>
			</div>

		</div>
		<style jsx>
			{`
				.card-skeleton-tab-product{
					max-width: 480px;
					margin-top: 12px;
				}
				.card-skeleton-tab-product__product{
					display: grid;
    				grid-template-columns: auto;
				}
				.card-skeleton-tab-product__product-data{
					display: flex;
					gap: 8px;
					align-items: center;
					margin-top: 39px;
				}
				.card-skeleton-tab-product__product-button{
					margin-top: 41px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
		`}
		</style>
	</>

);

export default Mobile;
